import React from 'react';
import styles from '../../Advisor.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How it works</span>
        <h2>Matched in three steps.</h2>
        <p className={styles.secLead}>Tell us what you need, meet your match, and get advice grounded in your real numbers.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h3>Tell us what you need</h3>
          <p>Bookkeeping, taxes, cash flow, or general guidance — we&apos;ll figure out the right fit.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="8" r="3.5" />
              <path d="M2 21a7 7 0 0 1 14 0M17 7l2 2 3-3" />
            </svg>
          </div>
          <h3>Get matched</h3>
          <p>We pair you with a vetted advisor who knows businesses like yours.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6 L9 17 l-5 -5" />
            </svg>
          </div>
          <h3>Get advice that fits</h3>
          <p>With your permission, they review your Fyntiq data — so the advice is built on your real numbers.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
